"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function MarkerPopupItem({ label, value }) {
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("p", { className: "card-text", children: [(0, jsx_runtime_1.jsx)("strong", { children: label }), ": ", value] }) }));
}
exports.default = MarkerPopupItem;
